import moment from 'moment';

// Convert array of objects to CSV format
export const exportToCSV = (data, filename) => {
    if (!data || data.length === 0) {
        alert('No data to export');
        return;
    }

    // Get headers from first object
    const headers = Object.keys(data[0]);

    // Create CSV content
    const csvContent = [
        headers.join(','), // Header row
        ...data.map((row) =>
            headers
                .map((header) => {
                    let value = row[header];

                    // Handle null/undefined values
                    if (value === null || value === undefined) {
                        value = '';
                    }

                    // Format dates
                    if (header.includes('date') || header.includes('created_at') || header.includes('scheduled_for')) {
                        value = moment(value).format('MM/DD/YYYY');
                    }

                    // Handle values that contain commas or quotes
                    if (typeof value === 'string' && (value.includes(',') || value.includes('"'))) {
                        value = `"${value.replace(/"/g, '""')}"`;
                    }

                    return value;
                })
                .join(',')
        ),
    ].join('\n');

    // Create and download file
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');

    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', `${filename}_${moment().format('YYYY-MM-DD')}.csv`);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};

// Specific export functions for each screen
export const exportUsersToCSV = (users) => {
    const formattedData = users.map((user) => ({
        Name: user.name,
        Email: user.email,
        'Total Advanced': user.totalAdvanced,
        'Enrollment Date': user.createdAt,
        'Activity Status': user.hasActivity ? 'Active (Advanced)' : 'No Activity',
    }));

    exportToCSV(formattedData, 'users_export');
};

export const exportLedgerToCSV = (ledger) => {
    const formattedData = ledger.map((item) => ({
        'Account Number': item.account_number,
        'Pay Period': item.pay_period,
        Amount: item.amount,
        Type: item.type === 'advance' ? 'Advance' : 'Service Fee',
        Date: item.created_at,
    }));

    exportToCSV(formattedData, 'ledger_export');
};

export const exportReconciliationToCSV = (reconciliation) => {
    const formattedData = reconciliation.map((item) => ({
        'Account Name': item.account_name,
        Email: item.email,
        'Amount Due': item.amount_due,
        'Days Past Due': item.days_past_due,
        'Pay Period': item.pay_period,
        'Scheduled For': item.scheduled_for,
        'Client ID': item.client_id,
    }));

    exportToCSV(formattedData, 'reconciliation_export');
};
